module.exports = __webpack_public_path__ + "img/hermione_as_a_cat.8dbb0b43.jpg";